export default function SocialSection() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="h-px w-10 bg-gold-500" />
          <span className="text-gold-500 text-xs uppercase tracking-[0.25em] font-sans font-semibold">Stay Connected</span>
          <div className="h-px w-10 bg-gold-500" />
        </div>

        <h2 className="font-serif text-4xl md:text-5xl text-charcoal-800 mb-4">
          Follow Our <em className="italic text-blush-500">Sweet Journey</em>
        </h2>
        <p className="text-warm-gray text-base md:text-lg font-sans font-light leading-relaxed mb-12">
          See our latest creations, behind-the-scenes baking, and seasonal specials on Instagram and Facebook. Tag us in your celebrations!
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          {/* Instagram */}
          <a
            href="https://www.instagram.com/sherry_sweet_celebrations/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="group flex flex-col items-center gap-4 bg-blush-50 hover:bg-blush-500 border border-blush-200 hover:border-blush-500 rounded-2xl px-12 py-8 transition-all duration-300 cursor-pointer w-full sm:w-auto"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-blush-500 group-hover:bg-white rounded-full transition-colors duration-300">
              <i className="ri-instagram-line text-3xl text-white group-hover:text-blush-500 transition-colors duration-300" />
            </div>
            <div>
              <p className="text-charcoal-800 group-hover:text-white font-serif text-lg font-semibold transition-colors duration-300">Instagram</p>
              <p className="text-warm-gray group-hover:text-blush-100 text-sm font-sans mt-1 transition-colors duration-300">@sherry_sweet_celebrations</p>
            </div>
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/scbakeacake"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="group flex flex-col items-center gap-4 bg-gold-300/20 hover:bg-gold-500 border border-gold-300 hover:border-gold-500 rounded-2xl px-12 py-8 transition-all duration-300 cursor-pointer w-full sm:w-auto"
          >
            <div className="w-16 h-16 flex items-center justify-center bg-gold-500 group-hover:bg-white rounded-full transition-colors duration-300">
              <i className="ri-facebook-fill text-3xl text-white group-hover:text-gold-600 transition-colors duration-300" />
            </div>
            <div>
              <p className="text-charcoal-800 group-hover:text-white font-serif text-lg font-semibold transition-colors duration-300">Facebook</p>
              <p className="text-warm-gray group-hover:text-gold-100 text-sm font-sans mt-1 transition-colors duration-300">@scbakeacake</p>
            </div>
          </a>
        </div>

        <p className="mt-10 text-warm-gray text-sm font-sans">
          <em>Share your Sweet Celebrations moment with <strong className="text-blush-500">#SweetCelebrationsLubbock</strong></em>
        </p>
      </div>
    </section>
  );
}
